import { LoadableAfterPaint } from '@confluence/loadable';

export const ConnectAddon = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ConnectAddon" */ './ConnectAddon')).ConnectAddon,
	name: 'ConnectAddonNext',
});

export type { ConnectAddonDescriptor } from './ConnectAddon';
